import { ThemeComponents } from '@chakra-ui/react';

const components: ThemeComponents = {
  Input: {
    baseStyle: {
      field: {
        bg: 'bg_main_input',
        _disabled: {
          _dark: {
            opacity: 0.4,
          },
          _light: {
            bg: 'grey.300',
          },
          cursor: 'not-allowed',
        },
        _focus: {
          border: 'border_main',
        },
        border: 'border_gray_solid',
      },
    },
    defaultProps: {
      variant: 'dark_mode',
    },
  },
  Textarea: {
    baseStyle: {
      bg: 'bg_main_input',
      _disabled: {
        _dark: {
          opacity: 0.4,
        },
        _light: {
          bg: 'grey.300',
        },
        cursor: 'not-allowed',
      },
      _focus: {
        border: 'border_main',
      },
    },
    defaultProps: {
      variant: 'dark_mode',
    },
  },
  Button: {
    variants: {
      submit: {
        bg: 'main_color',
        _disabled: {
          opacity: 0.8,
        },
        _hover: {
          opacity: 0.8,
        },
      },
      submit_summary: {
        bg: 'main_summary_color',
        _disabled: {
          opacity: 0.8,
        },
        _hover: {
          opacity: 0.8,
        },
      },
      link: {
        _dark: {
          bg: 'none',
        },
        _light: {
          bg: 'none',
        },
      },
      ghost: {
        _light: {
          _hover: {
            bg: 'gray.300',
          },
        },
      },
      action: {
        _light: {
          _hover: {
            bg: 'gray.400',
          },
          bg: 'gray.300',
        },
        _dark: {
          _hover: {
            bg: 'grey.500',
          },
          bg: 'grey.400',
        },
      },
      amatrium_submit: {
        _dark: {
          bg: 'main_color',
          color: 'color_main_text',
        },
        _light: {
          bg: 'primary.500',
          color: 'grey.50',
        },
        _hover: {
          opacity: 0.8,
        },
        _disabled: {
          opacity: 0.8,
        },
      },
      amatrium_view_btn: {
        _dark: {
          bg: 'main_summary_color',
          color: 'color_main_text',
        },
        _light: {
          bg: 'primary.500',
          color: 'grey.50',
        },
        _hover: {
          opacity: 0.8,
        },
        _disabled: {
          opacity: 0.8,
        },
      },
      amatrium_back_btn: {
        _dark: {
          bg: 'sub_main_color',
          color: 'color_main_text',
        },
        _light: {
          bg: 'primary.500',
          color: 'grey.50',
        },
        _hover: {
          opacity: 0.8,
        },
        _disabled: {
          opacity: 0.8,
        },
      },
      cancel: {
        _dark: {
          bg: 'grey.700',
          color: 'color_main_text',
          _hover: {
            bg: 'grey.600',
          },
        },
        _light: {
          bg: 'grey.100',
          color: 'color_main_text',
          _hover: {
            bg: 'grey.200',
          },
        },
      },
      // ── Reskin DS button variants (design-guidelines.md §4) ──
      'ds-primary': {
        bg: 'primary.solid',
        color: 'primary.on',
        fontWeight: 600,
        boxShadow: 'ds_xs',
        _hover: { bg: 'primary.hover', _disabled: { bg: 'primary.solid' } },
        _active: { transform: 'translateY(1px)' },
        _disabled: { opacity: 0.5, cursor: 'not-allowed' },
      },
      'ds-outline': {
        bg: 'bg.surface',
        color: 'text.default',
        border: '1px solid',
        borderColor: 'border.strong',
        fontWeight: 600,
        _hover: { borderColor: 'primary.solid', color: 'primary.solid' },
        _active: { transform: 'translateY(1px)' },
        _disabled: { opacity: 0.5, cursor: 'not-allowed' },
      },
      'ds-ghost': {
        bg: 'transparent',
        color: 'text.muted',
        fontWeight: 600,
        _hover: { bg: 'primary.soft', color: 'primary.solid' },
        _active: { transform: 'translateY(1px)' },
        _disabled: { opacity: 0.5, cursor: 'not-allowed' },
      },
      'ds-soft': {
        bg: 'primary.soft',
        color: 'primary.solid',
        fontWeight: 600,
        _hover: { bg: 'primary.solid', color: 'primary.on' },
        _active: { transform: 'translateY(1px)' },
        _disabled: { opacity: 0.5, cursor: 'not-allowed' },
      },
      'ds-danger': {
        bg: 'state.error',
        color: '#fff',
        fontWeight: 600,
        _hover: { filter: 'brightness(0.94)' },
        _active: { transform: 'translateY(1px)' },
        _disabled: { opacity: 0.5, cursor: 'not-allowed' },
      },
      'ds-danger-soft': {
        bg: 'state.errorSoft',
        color: 'state.error',
        fontWeight: 600,
        _hover: { bg: 'state.error', color: '#fff' },
        _active: { transform: 'translateY(1px)' },
        _disabled: { opacity: 0.5, cursor: 'not-allowed' },
      },
    },
    sizes: {
      // DS sizes — dùng kèm ds-* variants
      'ds-sm': { h: '32px', minW: '32px', fontSize: 'sm', px: 3, borderRadius: 'sm' },
      'ds-md': { h: '40px', minW: '40px', fontSize: 'md', px: 4, borderRadius: 'md' },
      'ds-lg': { h: '46px', minW: '46px', fontSize: 'md', px: 6, borderRadius: 'md' },
    },
    baseStyle: {
      fontWeight: 'normal',
      _focus: {
        border: 0,
        boxShadow: 0,
      },
      _active: {
        border: 0,
        boxShadow: 0,
      },
    },
    defaultProps: {
      variant: 'solid',
    },
  },
  IconButton: {
    baseStyle: {
      _focus: {
        border: 0,
        boxShadow: 0,
      },
    },
  },
  Link: {
    variants: {
      selected: {
        _dark: {
          color: 'grey.50',
          bg: 'transparent',
        },
        _light: {
          color: 'black',
          bg: 'amatrium_border',
        },
      },
      button: {
        _dark: {
          _activeLink: {
            color: 'grey.50',
            bg: 'main_color',
          },
        },
        _light: {
          _activeLink: {
            color: 'grey.50',
            bg: 'primary.500',
          },
        },
      },
      dropdown: {
        _dark: {
          color: 'grey.300',
          bg: 'transparent',
          _hover: {
            bg: 'grey.700',
            color: 'grey.50',
          },
        },
        // _light: {
        //   color: "black",
        //   bg: "amatrium_border",
        // },
      },
    },
    baseStyle: {
      _focus: {
        border: '0px',
        boxShadow: '0px',
      },
      _hover: {
        textDecoration: 'none',
      },
      _dark: {
        color: 'grey.500',
        _hover: {
          bg: 'grey.600',
          color: 'grey.50',
        },
      },
      _light: {
        color: 'amatrium.800',
        _hover: {
          bg: 'amatrium_border',
          color: 'black',
        },
      },
      fontWeight: '600',
    },
    defaultProps: {
      variant: 'default',
    },
  },
  Tag: {
    baseStyle: {
      background: '#E8DAF3',
      borderRadius: '0.75rem',
      px: '0.75rem',
    },
  },
  Heading: {
    baseStyle: {
      fontFamily: 'montserrat',
      fontWeight: 500,
      color: 'color_main_text',
    },
  },
  FormLabel: {
    baseStyle: {
      color: 'color_main_text',
    },
  },
  Table: {
    baseStyle: {
      color: 'color_main_text',
    },
  },
  Tooltip: {
    baseStyle: (props: any) => ({
      bg: props.colorMode === 'dark' ? '#363f50' : 'white',
      color: props.colorMode === 'dark' ? 'white' : 'black',
    }),
  },
  // ── Reskin DS components (design-guidelines.md §4) ──
  Card: {
    parts: ['container', 'header', 'body', 'footer'],
    baseStyle: {
      container: {
        bg: 'bg.surface',
        borderWidth: '1px',
        borderColor: 'border.default',
        borderRadius: 'lg',
        boxShadow: 'ds_sm',
      },
    },
    variants: {
      'ds-hover': {
        container: {
          transition: 'box-shadow 0.18s ease-out, border-color 0.18s ease-out',
          _hover: { boxShadow: 'ds_md', borderColor: 'border.strong' },
        },
      },
    },
  },
  Badge: {
    baseStyle: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 1,
      h: '22px',
      px: 2,
      borderRadius: 'sm',
      fontSize: 'xs',
      fontWeight: 600,
      textTransform: 'none',
      lineHeight: 1,
    },
    variants: {
      'ds-neutral': {
        bg: 'bg.canvas',
        color: 'text.muted',
        borderWidth: '1px',
        borderColor: 'border.default',
      },
      'ds-primary': { bg: 'primary.soft', color: 'primary.solid' },
      'ds-success': { bg: 'state.successSoft', color: 'state.success' },
      'ds-warning': { bg: 'state.warningSoft', color: 'state.warning' },
      'ds-error': { bg: 'state.errorSoft', color: 'state.error' },
    },
  },
  Switch: {
    variants: {
      ds: {
        track: {
          bg: 'border.strong',
          _checked: { bg: 'primary.solid' },
        },
        thumb: { bg: '#fff', boxShadow: 'ds_xs' },
      },
    },
  },
  Progress: {
    variants: {
      ds: {
        track: {
          bg: 'bg.canvas',
          borderWidth: '1px',
          borderColor: 'border.default',
          borderRadius: 'full',
        },
        filledTrack: { bg: 'primary.solid' },
      },
    },
  },
};

export default components;
